import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Paginator } from 'primereact/paginator';
import { Button } from 'primereact/button';
import CBMediaQuery from '../../shared/CBMediaQuery';
import CBSelectFilters from '../../shared/CBSelectFilters';
import CBPromptModal from '../../shared/CBPromptModal';
import CBMobileCard from '../../shared/CBMobileCard';
import { getStyle } from '../../../utils/utils';
import ComposeInvoiceDialog from './ComposeInvoiceDialog';
import ConsolidatedInvoiceDetail from './ConsolidatedInvoiceDetail';
import {
  fetchConsolidatedInvoices as _fetchConsolidatedInvoices,
  deleteConsolidatedInvoice as _deleteConsolidatedInvoice,
} from '../../../actions/chainActions';
import { API_URL } from '../../../config';

function formatPrice(value) {
  if (value === null || value === undefined) return '-';
  return Number(value).toLocaleString('fi-FI', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }) + ' \u20AC';
}

function formatDate(dateStr) {
  if (!dateStr) return '-';
  return new Date(dateStr).toLocaleDateString('fi-FI');
}

var consolidatedStatusColors = {
  draft: { bg: 'rgba(255, 255, 255, 0.1)', color: 'rgba(255, 255, 255, 0.7)', border: 'rgba(255, 255, 255, 0.2)' },
  ready: { bg: 'rgba(129, 199, 132, 0.2)', color: '#A5D6A7', border: 'rgba(129, 199, 132, 0.4)' },
  exporting: { bg: 'rgba(255, 213, 79, 0.2)', color: '#FFE082', border: 'rgba(255, 213, 79, 0.4)' },
  exported: { bg: 'rgba(100, 181, 246, 0.2)', color: '#90CAF9', border: 'rgba(100, 181, 246, 0.4)' },
};

function getStatusBadgeStyle(status) {
  var c = consolidatedStatusColors[status] || consolidatedStatusColors.draft;
  return {
    display: 'inline-block',
    padding: '2px 10px',
    borderRadius: 20,
    fontSize: 11,
    fontWeight: 600,
    backgroundColor: c.bg,
    color: c.color,
    border: '1px solid ' + c.border,
  };
}

var creditBadgeStyle = {
  display: 'inline-block',
  padding: '2px 10px',
  borderRadius: 20,
  fontSize: 11,
  fontWeight: 600,
  backgroundColor: 'rgba(229, 115, 115, 0.2)',
  color: '#EF9A9A',
  border: '1px solid rgba(229, 115, 115, 0.4)',
};

var creditPendingBadgeStyle = {
  ...creditBadgeStyle,
  backgroundColor: 'rgba(255, 183, 77, 0.2)',
  color: '#FFB74D',
  border: '1px solid rgba(255, 183, 77, 0.4)',
};

var copyBadgeStyle = {
  ...creditBadgeStyle,
  backgroundColor: 'rgba(100, 181, 246, 0.2)',
  color: '#90CAF9',
  border: '1px solid rgba(100, 181, 246, 0.4)',
};

class ConsolidatedInvoiceList extends React.Component {
  state = {
    filters: {},
    page: 1,
    composeDialogOpen: false,
    previewInvoiceId: null,
    deleteModalOpen: false,
    deleteTargetId: null,
  };

  componentWillMount() {
    this.refetch();
    if (this.props.openConsolidatedId) {
      this.setState({ previewInvoiceId: this.props.openConsolidatedId });
      if (this.props.onClearOpenConsolidated) {
        this.props.onClearOpenConsolidated();
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.openConsolidatedId && this.props.openConsolidatedId !== prevProps.openConsolidatedId) {
      this.setState({ previewInvoiceId: this.props.openConsolidatedId });
      if (this.props.onClearOpenConsolidated) {
        this.props.onClearOpenConsolidated();
      }
    }
    if (this.props.chainId && this.props.chainId !== prevProps.chainId) {
      this.setState({ page: 1, filters: {} }, function () {
        this.refetch();
      }.bind(this));
    }
  }

  refetch = function () {
    var chainId = this.props.chainId;
    if (!chainId) return;
    var filters = this.state.filters;
    var page = this.state.page;
    var params = { ...filters, page: page, ordering: '-created_at' };
    this.props.fetchConsolidatedInvoices(chainId, params);
  };

  changeFilter = function (name, value) {
    var filters = { ...this.state.filters };
    if (value) {
      filters[name] = value;
    } else {
      delete filters[name];
    }
    this.setState({ filters: filters, page: 1 }, function () {
      this.refetch();
    }.bind(this));
  };

  changePage = function (event) {
    var pagination = this.props.consolidatedInvoicesPagination;
    var pageSize = pagination && pagination.page_size ? pagination.page_size : 20;
    var newPage = Math.floor(event.first / pageSize) + 1;
    this.setState({ page: newPage }, function () {
      this.refetch();
    }.bind(this));
  };

  openCompose = function () {
    this.setState({ composeDialogOpen: true });
  };

  closeCompose = function () {
    this.setState({ composeDialogOpen: false });
    this.refetch();
  };

  openPreview = function (invoiceId) {
    this.setState({ previewInvoiceId: invoiceId });
  };

  closePreview = function () {
    this.setState({ previewInvoiceId: null });
    this.refetch();
  };

  downloadPdf = function (invoiceId) {
    window.open(API_URL + '/uiapi/1/chain_consolidated_invoice/' + invoiceId + '/report/', '_blank');
  };

  openDeleteModal = function (invoiceId) {
    this.setState({ deleteModalOpen: true, deleteTargetId: invoiceId });
  };

  closeDeleteModal = function () {
    this.setState({ deleteModalOpen: false, deleteTargetId: null });
  };

  confirmDelete = function () {
    var deleteTargetId = this.state.deleteTargetId;
    if (deleteTargetId) {
      this.props.deleteConsolidatedInvoice(deleteTargetId);
    }
    this.closeDeleteModal();
  };

  getCustomerOptions = function () {
    var chainCareServices = this.props.chainCareServices;
    var t = this.props.t;
    var options = [{ value: '', label: t('allCustomers') }];
    if (chainCareServices && chainCareServices.length > 0) {
      chainCareServices.forEach(function (cs) {
        if (cs.id) {
          options.push({
            value: String(cs.id),
            label: cs.organization_name || '-',
          });
        }
      });
    }
    return options;
  };

  getStatusOptions = function () {
    var t = this.props.t;
    return [
      { value: '', label: t('allStatuses') },
      { value: 'draft', label: t('invoiceStatusDraft') },
      { value: 'ready', label: t('invoiceStatusReady') },
      { value: 'exported', label: t('invoiceStatusExported') },
    ];
  };

  getStatusLabel = function (status) {
    var t = this.props.t;
    var labels = {
      draft: t('invoiceStatusDraft'),
      ready: t('invoiceStatusReady'),
      exporting: t('invoiceStatusExporting'),
      exported: t('invoiceStatusExported'),
    };
    return labels[status] || status;
  };

  renderCreditTags = function (inv) {
    var t = this.props.t;
    var tags = [];
    if (inv.credits_invoice) {
      tags.push(
        <span key='cn' style={{ ...creditBadgeStyle, marginLeft: 6 }}>
          {t('creditNote')}
        </span>
      );
    }
    if (inv.credit_note_id && inv.credit_note_status === 'exported') {
      tags.push(
        <span key='credited' style={{ ...creditBadgeStyle, marginLeft: 6 }}>
          {t('creditedBadge')}
        </span>
      );
    }
    if (inv.credit_note_id && inv.credit_note_status !== 'exported') {
      tags.push(
        <span key='creditPending' style={{ ...creditPendingBadgeStyle, marginLeft: 6 }}>
          {t('creditPendingBadge')}
        </span>
      );
    }
    if (inv.copied_from) {
      tags.push(
        <span key='copy' style={{ ...copyBadgeStyle, marginLeft: 6 }}>
          {t('copiedFromBadge')} #{inv.copied_from}
        </span>
      );
    }
    return tags;
  };

  handleNavigateToInvoice = function (invoiceId) {
    this.setState({ previewInvoiceId: invoiceId });
    this.refetch();
  };

  renderCard = (inv) => {
    var t = this.props.t;
    var periodStr = formatDate(inv.period_start) + ' – ' + formatDate(inv.period_end);
    var options = [
      {
        label: t('downloadPdf'),
        icon: 'pi pi-file-pdf',
        command: () => { this.downloadPdf(inv.id); },
      },
    ];
    if (inv.status !== 'exported') {
      options.push({
        label: t('delete'),
        icon: 'pi pi-trash',
        command: () => { this.openDeleteModal(inv.id); },
      });
    }
    return (
      <CBMobileCard
        key={inv.id}
        title={inv.care_service_organization_name || inv.customer_name || '-'}
        dialogTitle={inv.care_service_organization_name || inv.customer_name || '-'}
        subtitle={periodStr}
        badges={[
          <span key='status' style={getStatusBadgeStyle(inv.status)}>{this.getStatusLabel(inv.status)}</span>,
        ].concat(this.renderCreditTags(inv))}
        fields={[
          { label: t('amount'), value: formatPrice(inv.total_amount) },
          { label: t('created'), value: formatDate(inv.created_at) },
        ]}
        allFields={[
          { label: t('customer'), value: inv.care_service_organization_name || inv.customer_name || '-' },
          { label: t('period'), value: periodStr },
          { label: t('amount'), value: formatPrice(inv.total_amount) },
          { label: t('status'), value: this.getStatusLabel(inv.status) },
          { label: t('created'), value: formatDate(inv.created_at) },
        ]}
        options={options}
        onClick={() => this.openPreview(inv.id)}
      />
    );
  };

  renderMobileList = (screenSize) => {
    var t = this.props.t;
    var invoices = this.props.consolidatedInvoices;
    var pagination = this.props.consolidatedInvoicesPagination;
    return (
      <div style={getStyle(screenSize, styles, 'mobileListContainer')}>
        {invoices && invoices.length > 0 ? (
          invoices.map((inv) => this.renderCard(inv))
        ) : (
          <div style={styles.default.noDataCell}>{t('noConsolidatedInvoices')}</div>
        )}
        {pagination && pagination.count > 0 && (
          <div style={styles.default.paginatorContainer}>
            <Paginator
              first={(pagination.page_size * (pagination.current_page - 1))}
              rows={pagination.page_size}
              totalRecords={pagination.count}
              onPageChange={this.changePage.bind(this)}
            />
          </div>
        )}
      </div>
    );
  };

  render() {
    var t = this.props.t;
    var invoices = this.props.consolidatedInvoices;
    var loadStatus = this.props.consolidatedInvoicesStatus;
    var pagination = this.props.consolidatedInvoicesPagination;
    var chainCareServices = this.props.chainCareServices;
    var filters = this.state.filters;
    var isLoading = loadStatus && loadStatus.loading;

    return (
      <CBMediaQuery>
        {function (screenSize) {
          return (
            <div style={getStyle(screenSize, styles, 'container')}>
              {/* Top actions */}
              <div style={getStyle(screenSize, styles, 'topActions')}>
                <Button
                  onClick={this.openCompose.bind(this)}
                  label={t('composeInvoice')}
                  icon="pi pi-plus"
                  style={styles.default.composeButton}
                  size="small"
                />
              </div>

              {/* Filters */}
              <div style={getStyle(screenSize, styles, 'filterRow')}>
                <CBSelectFilters
                  name="care_service"
                  options={this.getCustomerOptions()}
                  onChange={function (changed) {
                    this.changeFilter('care_service', changed.care_service);
                  }.bind(this)}
                  value={filters.care_service || ''}
                  selectStyle={getStyle(screenSize, styles, 'selectFilter')}
                />
                <CBSelectFilters
                  name="status"
                  options={this.getStatusOptions()}
                  onChange={function (changed) {
                    this.changeFilter('status', changed.status);
                  }.bind(this)}
                  value={filters.status || ''}
                  selectStyle={getStyle(screenSize, styles, 'selectFilter')}
                />
              </div>

              {/* Table (desktop) / Cards (mobile) */}
              {screenSize === 'small' ? (
                this.renderMobileList(screenSize)
              ) : (
              <div style={getStyle(screenSize, styles, 'tableContainer')}>
                {isLoading ? (
                  <div style={styles.default.loadingContainer}>
                    <p style={styles.default.loadingText}>Ladataan...</p>
                  </div>
                ) : (
                  <div>
                    <table style={getStyle(screenSize, styles, 'table')}>
                      <thead>
                        <tr>
                          <th style={styles.default.th}>{t('customer')}</th>
                          <th style={styles.default.th}>{t('period')}</th>
                          <th style={{ ...styles.default.th, textAlign: 'right' }}>{t('amount')}</th>
                          <th style={styles.default.th}>{t('status')}</th>
                          <th style={styles.default.th}>{t('created')}</th>
                          <th style={{ ...styles.default.th, textAlign: 'right' }}>{t('actions')}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {invoices && invoices.length > 0 ? (
                          invoices.map(function (inv) {
                            var periodStr = formatDate(inv.period_start) + ' \u2013 ' + formatDate(inv.period_end);
                            return (
                              <tr
                                key={inv.id}
                                style={{ ...styles.default.tableRow, cursor: 'pointer' }}
                                onClick={function () { this.openPreview(inv.id); }.bind(this)}
                              >
                                <td style={styles.default.td}>
                                  {inv.care_service_organization_name || inv.customer_name || '-'}
                                </td>
                                <td style={styles.default.td}>{periodStr}</td>
                                <td style={{ ...styles.default.td, textAlign: 'right', fontWeight: 600 }}>
                                  {formatPrice(inv.total_amount)}
                                </td>
                                <td style={styles.default.td}>
                                  <span style={getStatusBadgeStyle(inv.status)}>
                                    {this.getStatusLabel(inv.status)}
                                  </span>
                                  {this.renderCreditTags(inv)}
                                </td>
                                <td style={styles.default.td}>{formatDate(inv.created_at)}</td>
                                <td style={{ ...styles.default.td, textAlign: 'right' }}>
                                  <div style={styles.default.actionButtons}>
                                    <Button
                                      icon="pi pi-file-pdf"
                                      text
                                      rounded
                                      onClick={function (e) { e.stopPropagation(); this.downloadPdf(inv.id); }.bind(this)}
                                      style={styles.default.actionBtn}
                                      title={t('downloadPdf')}
                                    />
                                    {inv.status !== 'exported' && (
                                      <Button
                                        icon="pi pi-trash"
                                        text
                                        rounded
                                        onClick={function (e) { e.stopPropagation(); this.openDeleteModal(inv.id); }.bind(this)}
                                        style={{ ...styles.default.actionBtn, color: 'rgba(229, 115, 115, 0.7)' }}
                                        title={t('delete')}
                                      />
                                    )}
                                  </div>
                                </td>
                              </tr>
                            );
                          }.bind(this))
                        ) : (
                          <tr>
                            <td colSpan={6} style={styles.default.noDataCell}>
                              {t('noConsolidatedInvoices')}
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>

                    {pagination && pagination.count > 0 && (
                      <div style={styles.default.paginatorContainer}>
                        <Paginator
                          first={(pagination.page_size * (pagination.current_page - 1))}
                          rows={pagination.page_size}
                          totalRecords={pagination.count}
                          onPageChange={this.changePage.bind(this)}
                        />
                      </div>
                    )}
                  </div>
                )}
              </div>
              )}

              {this.state.composeDialogOpen && (
                <ComposeInvoiceDialog
                  chainId={this.props.chainId}
                  chainCareServices={chainCareServices}
                  onClose={this.closeCompose.bind(this)}
                />
              )}

              {this.state.previewInvoiceId && (
                <ConsolidatedInvoiceDetail
                  invoiceId={this.state.previewInvoiceId}
                  onClose={this.closePreview.bind(this)}
                  onNavigateToInvoice={this.handleNavigateToInvoice.bind(this)}
                />
              )}

              <CBPromptModal
                modalIsOpen={this.state.deleteModalOpen}
                closeModal={this.closeDeleteModal.bind(this)}
                performAction={this.confirmDelete.bind(this)}
                title={t('delete')}
                text={t('confirmDeleteInvoice')}
                buttonText={t('delete')}
              />
            </div>
          );
        }.bind(this)}
      </CBMediaQuery>
    );
  }
}

var styles = {
  default: {
    container: {
      padding: '16px 16px',
    },
    mobileListContainer: {
      paddingBottom: 8,
    },
    topActions: {
      display: 'flex',
      justifyContent: 'flex-end',
      marginBottom: 16,
    },
    composeButton: {
      backgroundColor: 'rgba(255, 255, 255, 0.15)',
      border: '1px solid rgba(255, 255, 255, 0.3)',
      color: '#fff',
      fontWeight: 600,
    },
    filterRow: {
      display: 'flex',
      flexDirection: 'row',
      gap: 12,
      alignItems: 'center',
      flexWrap: 'wrap',
      marginBottom: 16,
    },
    selectFilter: {
      width: 200,
      marginLeft: 0,
      marginRight: 0,
    },
    tableContainer: {
      overflowX: 'auto',
    },
    table: {
      width: '100%',
      borderCollapse: 'collapse',
      whiteSpace: 'nowrap',
    },
    th: {
      padding: '10px 12px',
      color: 'rgba(255, 255, 255, 0.6)',
      fontSize: 12,
      fontWeight: 600,
      textTransform: 'uppercase',
      borderBottom: '1px solid rgba(255, 255, 255, 0.15)',
      textAlign: 'left',
    },
    td: {
      padding: '12px 12px',
      color: '#fff',
      fontSize: 14,
      borderBottom: '1px solid rgba(255, 255, 255, 0.08)',
    },
    tableRow: {
      transition: 'background-color 0.15s',
    },
    actionButtons: {
      display: 'flex',
      gap: 4,
      justifyContent: 'flex-end',
    },
    actionBtn: {
      color: 'rgba(255, 255, 255, 0.6)',
      width: 32,
      height: 32,
    },
    noDataCell: {
      padding: '32px 16px',
      color: 'rgba(255, 255, 255, 0.5)',
      fontSize: 14,
      textAlign: 'center',
    },
    loadingContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: 200,
    },
    loadingText: {
      color: 'rgba(255, 255, 255, 0.7)',
      fontSize: 14,
    },
    paginatorContainer: {
      display: 'flex',
      justifyContent: 'center',
      paddingTop: 16,
      paddingBottom: 24,
    },
  },
};

function mapStateToProps(state) {
  return {
    consolidatedInvoices: state.chain.consolidatedInvoices,
    consolidatedInvoicesPagination: state.chain.consolidatedInvoicesPagination,
    consolidatedInvoicesStatus: state.chain.consolidatedInvoicesStatus,
  };
}

export default connect(
  mapStateToProps,
  {
    fetchConsolidatedInvoices: _fetchConsolidatedInvoices,
    deleteConsolidatedInvoice: _deleteConsolidatedInvoice,
  },
)(translate('ChainInvoicingView')(ConsolidatedInvoiceList));
